import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AbstractApi } from './abstract.api';
import { Pool } from './pool.api';

export enum EventProductType {
  MASTER = 'master',
  CONNECT = 'connect',
  PRODUCT = 'product',
}

export enum EventProductTypeEnum {
  ADVICE = 'advice',
  STATUS = 'status',
  ALERT = 'alert',
}

export enum EventProductFunctionnalityEnum {
  FILTRATION = 'filtration',
  LIGHTING = 'lighting',
  DISINFECTION = 'disinfection',
  MEASURE = 'measure',
  TREATMENTPH = 'InjectionPH',
  COVER = 'cover',
  NCC = 'ncc',
  BLOWER = 'blower',
  ROBOT = 'robot',
  CONNECTIVITY = 'connectivity',
  PAC = 'heating',
  MASTER = 'master',
  WATER_LEVEL = 'WaterLevel',
  TREATMENTCLPH = 'InjectionCLPH',
}

export type PoolProductEvent = {
  id?: string;
  createdAt?: string;
  code?: number;
  functionnalityName?: string;
  functionnality?: string;
  category?: string;
  type?: string;
  isNotifiable?: boolean;
  isSendByNotification?: boolean;
  message?: string;
};

export interface PoolProductEventList {
  count: number;
  data: PoolProductEvent[];
}

@Injectable({
  providedIn: 'root',
})
export class PoolEventsApi extends AbstractApi {
  public getPoolEvents(
    poolId: string,
    length: number = 10,
    offset: number = 0,
    startDate: number | null = null,
    endDate: number | null = null,
    filterFunctionnality: string[] | null = null,
    notificationFilter: boolean | null = null,
    filterCodeEvent: number | null = null,
    filterTypeEvent: string | null = null,
  ): Promise<PoolProductEventList> {
    return firstValueFrom(
      this.http.get<PoolProductEventList>(
        `${this.backend}/api/v1/pool/${poolId}/event`,
        {
          params: {
            length: length.toString(),
            offset: offset.toString(),
            ...(startDate !== null && { startDate: startDate.toString() }),
            ...(endDate !== null && { endDate: endDate.toString() }),
            ...(filterFunctionnality !== null &&
              filterFunctionnality.length > 0 && {
                filterFunctionnality: filterFunctionnality.join(','),
              }),
            ...(notificationFilter !== null && { notificationFilter }),
            ...(filterCodeEvent !== null && {
              filterCodeEvent: filterCodeEvent.toString(),
            }),
            ...(filterTypeEvent !== null && { filterTypeEvent }),
            webPagination: true,
          },
        },
      ),
    );
  }

  public getLastPoolEvents(
    poolId: string,
    length: number = 10,
    offset: number = 0,
    startDate: number | null = null,
    endDate: number | null = null,
  ): Promise<PoolProductEvent[]> {
    return firstValueFrom(
      this.http.get<PoolProductEvent[]>(
        `${this.backend}/api/v1/pool/${poolId}/lastEvents`,
        {
          params: {
            length: length.toString(),
            offset: offset.toString(),
            ...(startDate !== null && { startDate: startDate.toString() }),
            ...(endDate !== null && { endDate: endDate.toString() }),
          },
        },
      ),
    );
  }

  public patchPoolEvents(
    poolId: string,
    eventsId: string[],
  ): Promise<PoolProductEvent[]> {
    return firstValueFrom(
      this.http.patch<PoolProductEvent[]>(
        `${this.backend}/api/v1/pool/${poolId}/event`,
        eventsId,
      ),
    );
  }

  public getPoolProductEvents(
    poolId: string,
    productType: EventProductType,
    modelIdentifier: string,
    length: number = 10,
    offset: number = 0,
    startDate: number | null = null,
    endDate: number | null = null,
    filterFunctionnality: string | null = null,
    notificationFilter: boolean = false,
    filterCodeEvent: number | null = null,
    filterTypeEvent: string | null = null,
  ): Promise<PoolProductEvent[]> {
    return firstValueFrom(
      this.http.get<PoolProductEvent[]>(
        `${this.backend}/api/v1/pool/${poolId}/${productType}/${modelIdentifier}/event`,
        {
          params: {
            length: length.toString(),
            offset: offset.toString(),
            ...(startDate !== null && { startDate: startDate.toString() }),
            ...(endDate !== null && { endDate: endDate.toString() }),
            ...(filterFunctionnality !== null && { filterFunctionnality }),
            notificationFilter: notificationFilter.toString(),
            ...(filterCodeEvent !== null && {
              filterCodeEvent: filterCodeEvent.toString(),
            }),
            ...(filterTypeEvent !== null && { filterTypeEvent }),
          },
        },
      ),
    );
  }

  public getPoolProductEventsForHistory(
    poolId: string,
    productType: EventProductType,
    modelIdentifier: string,
    startDate: number | null = null,
    endDate: number | null = null,
    filterCodeEvent: number | null = null,
    filterProperty: string | null = null,
    valueToMatch: number | null = null,
    mode: string | null = null,
  ): Promise<PoolProductEvent[]> {
    return firstValueFrom(
      this.http.get<PoolProductEvent[]>(
        `${this.backend}/api/v1/pool/${poolId}/${productType}/${modelIdentifier}/eventhistory`,
        {
          params: {
            ...(startDate !== null && { startDate: startDate.toString() }),
            ...(endDate !== null && { endDate: endDate.toString() }),
            ...(filterCodeEvent !== null && {
              filterCodeEvent: filterCodeEvent.toString(),
            }),
            ...(filterProperty !== null && { filterProperty }),
            ...(valueToMatch !== null && {
              valueToMatch: valueToMatch.toString(),
            }),
            ...(mode !== null && {
              mode: mode.toString(),
            }),
          },
        },
      ),
    );
  }
}
